<template>
  <div class="fallback-ui">
    <p class="welcome">Welcome 👋</p>

    <div class="content-middle">
      <img class="logo" src="@/assets/leyon_logo.jpg" alt="Leyon Logo" />
      <h2 class="main-text">Discover Freshness, Delight in Savings!</h2>
      <p class="sub-text">
        Thank you for being a part of our journey. Let’<span class="highlight"
          >s</span
        >
        ensure
        <span class="centered-line"> every customer leaves with a smile!</span>
      </p>
    </div>

    <div class="bottom-content">
      <img class="qr-code" src="@/assets/leyon_qr.jpg" alt="QR Code" />
      <a
        class="url"
        href="https://www.leyonsuper.com"
        target="_blank"
        rel="noopener noreferrer"
      >
        www.leyonsuper.com
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: "100dvw",
    },
    height: {
      type: String,
      default: "100dvh",
    },
  },
};
</script>

<style scoped>
.fallback-ui {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start; /* Changed from space-between to allow natural scrolling */
  height: 100dvh;
  overflow-y: auto; /* Enables vertical scrolling */
  background: #221e1d;
  color: #ffffff;
  text-align: center;
  padding: 5%;
  box-sizing: border-box; /* Ensures padding doesn't exceed 100dvh */
}

.welcome {
  font-size: 1.5rem;
  margin: 10px;
}

.content-middle {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 15px;
}

.logo {
  width: 15%;
  margin: 10px 0;
}

.main-text {
  font-size: 1.8rem;
  font-weight: 400;
  margin: 0;
}

.sub-text {
  font-size: 1.2rem;
  color: #b5b5b5;
  font-weight: lighter;
  font-style: italic;
  font-family: sans-serif;
}

.centered-line {
  display: block;
  white-space: nowrap;
  margin-top: 5px;
}

.bottom-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 5%;
}

.qr-code {
  width: 100px;
  height: 100px;
  margin-bottom: 10px;
}

.url {
  font-size: 1.2rem;
  font-family: monospace;
  color: #b5b5b5;
  font-weight: bold;
  text-decoration: none;
  letter-spacing: 0.15rem;
}

.url:hover {
  text-decoration: none;
}
</style>
